// Stepts for homepage
const talentpoolSteps = [
{
    element: ".table",
    popover: {
        className: 'first-step-popover-class',
        title: '🙋<br>Začíname',
        description: '<b>Toto je tvoja vlastná databáza zaujímavých uchádzačov, </b> ktorí ťa v minulosti zaujali, ale z nejakého dôvodu boli odmietnutí. Teraz ich môžeš opäť ľahko osloviť! 👌',
        position: 'center',
        showButtons: true,
    },

},
{
    element: "#filter_with_job-talentpool",
    popover: {
        title: ' ',
        description: '<b>Vo východiskovom stave </b> vidíš všetkých uchádzačov bez ohľadu na pozíciu.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".table",
    popover: {
        title: '🧑<br>Prehľad uchádzačov v archíve',
        description: 'Ku každému uchádzačovi si môžeš pridávať značky, skúsenosti, ★ hodnotenia a vlastné poznámky.',
        position: 'bottom',
        showButtons: true,
    },
    onNext: () => {
        setTimeout(function(){ $('#row-select-all').trigger('click'); }, 1000);

    }
},
{
    element: ".datatable-td",
    popover: {
        title: '🚀<br> Hromadné akcie',
        description: '<b>Tu je možné označiť uchádzačov, ktorí vyzerajú sľubne.</b> Potom môžeš v ponuke nižšie vybrať "Poslať do Hiringu" a vybraní uchádzači sa objavia medzi aktuálnymi uchádzačmi o zamestnanie',
        position: 'right',
        showButtons: true,
    },
    onNext: () => {
        setTimeout(function(){ $('#row-select-all').trigger('click'); }, 1000);
        $('#onboarding.collapse').collapse('show');
    }


},
// {
//     element: ".align-self-start",
//     popover: {
//         title: '🪄✨<br> Hromadný import uchádzačov',
//         description: 'Väčší počet uchádzačov, napr. z personálnej agentúry, je možné nahrať <b> z tabuľky (Excel alebo CSV).</b> Ak už teda máš nejakú vlastnú databázu uchádzačov, tu ju môžeš nahrať do svojho talentpoolu <b>jedným kliknutím</b> 🙂 ',
//         position: 'left-bottom',
//         showButtons: true,
//     },
//
// },


{
    element: "#sidebar",
    popover: {
        className: 'first-step-popover-class',
        title: 'Paráda!',
        description: 'Zisti, ako ti pomôžeme s onboardingom <br>(4 min)<br>',
        position: 'right-center',
        showButtons: true,
        showButtons: true,         // Do not show control buttons in footer
        doneBtnText: 'Áno, pokračovať ďalej',
        nextBtnText: 'Rozumiem',        // Next button text for this step
        prevBtnText: 'Späť',
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/onboarding#guide");

    }
},
]



export default talentpoolSteps
